import {
  faCheckCircle,
  faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dialog } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { closeToastDialog } from "../../../actions/progress";
import "./ToastDialog.scss";
const ToastDialog = ({ onClose, open, message, type = "SUCCESS" }) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    onClose();
    dispatch(closeToastDialog());
  };

  useEffect(() => {
    if (open) {
      if (type === "ERROR") {
        setTimeout(() => {
          handleClose();
        }, 3000);
      }
      if (type === "CANCELLABLE") {
      } else {
        setTimeout(() => {
          handleClose();
        }, 2000);
      }
    }
    return () => {};
  }, [open]);
  return (
    <Dialog
      maxWidth="xs"
      className="container toast-dialog"
      fullWidth={true}
      onClose={handleClose}
      open={open}
    >
      <div className="d-flex align-items-center justify-content-center flex-column p-5">
        <div className="icon-wrapper">
          {type === "SUCCESS" && (
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="toast-icon flag__green"
            />
          )}
          {type === "ERROR" && (
            <FontAwesomeIcon
              icon={faTimesCircle}
              className="toast-icon flag__red"
            />
          )}
        </div>
        {!Array.isArray(message) && <h5>{message}</h5>}
        {Array.isArray(message) && (
          <div style={{ textAlign: "center" }}>
            {message.map((mes, i) => {
              if (i === 0) {
                return <h4 key={i + "o"}>{mes}</h4>;
              }
              return <h6 key={i + "o"}>{mes}</h6>;
            })}
          </div>
        )}

        {type === "CANCELLABLE" && (
          <Button
            className="mt-3"
            style={{ color: "#ffffff", background: "#1DC56D" }}
            size="large"
            variant="contained"
            onClick={handleClose}
          >
            Close
          </Button>
        )}
      </div>
    </Dialog>
  );
};

export default ToastDialog;
